import {SESSION_STATUS, ISafezoneEventParams} from "../../../../analytics/analytics-data-layer.service.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";

interface IControlCenterEventNames {
    category: string;
    open: string;
    ready: string;
    closeExternal: string;
    closeInternal?: string;
}

export class ControlCenterAnalyticsHelper {
    private correlationID: string | null = null;
    private source: string | null = null;
    private sessionStatus: SESSION_STATUS = SESSION_STATUS.Partial;

    constructor(
        private eventNames: IControlCenterEventNames,
        private services: IServiceFactoryExtended
    ) {

    }

    setCorrelationID(c: string) {
        this.correlationID = c;
        return this;
    }

    setSource(s: string) {
        this.source = s;
        return this;
    }

    trackAppOpen() {
        this._pushSafezoneEvent(this.eventNames.open);
    }

    trackAppInitSuccess() {
        this.sessionStatus = SESSION_STATUS.Success;
        this._pushSafezoneEvent(this.eventNames.ready);
    }

    trackAppInitFailed() {
        this.sessionStatus = SESSION_STATUS.Failure;
        this._pushSafezoneEvent(this.eventNames.ready);
    }

    trackCloseExternal() {
        this._pushSafezoneEvent(this.eventNames.closeExternal);
    }

    trackCloseInternal() {
        if (this.eventNames.closeInternal) {
            this._pushSafezoneEvent(this.eventNames.closeInternal);
        }
    }

    private _pushSafezoneEvent(safezoneEvent: string) {
        this.services.analyticsDataLayer.pushSafezoneEvent({
            ...this._getEventParams(safezoneEvent, this.correlationID, this.source),
            session_status: this.sessionStatus
        });
    }
    protected _getEventParams(name: string, correlation_id: string, source: string): ISafezoneEventParams {
        return {
            action: name,
            category: this.eventNames.category,
            event: name,
            correlation_id: correlation_id,
            channel: source,
            label: undefined,
            local_time: (new Date()).toString()
        };
    }

}